import { Menu } from 'lucide-react';
import { ActionIcon, Box, Group, Image, Stack, Text } from '@mantine/core';
import { LogoBat } from '@/assets/login';
import { useAppStore } from '@/stores';
import styles from './Navbar.module.css';

const NavbarTop = () => {
  const { sideBarToggle } = useAppStore();

  return (
    <Group justify="space-between" p={16} className={styles.NavbarTop}>
      <Group gap={12}>
        <Box>
          <Image src={LogoBat} h={36} w="auto" />
        </Box>
        <Stack gap={0}>
          <Text fw={700} fz={18} c="dark.5">
            Human Capital
          </Text>
          <Text c="gray" fz={14}>
            Information System
          </Text>
        </Stack>
      </Group>
      <ActionIcon onClick={sideBarToggle} variant="subtle" c="black">
        <Menu />
      </ActionIcon>
    </Group>
  );
};

export default NavbarTop;
